(() => {
  if (window.BBOverlayManagerReady) return;
  window.BBOverlayManagerReady = true;
  const closeMenu = () => {
    document.dispatchEvent(new Event('bb:close-menu'));
    document.querySelectorAll('[data-bb-quick-access][open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    });
    document.body.classList.remove('bb-quick-access-open');
  };
  const closeSearch = (immediate = false) => {
    const dialog = document.querySelector('#search-modal dialog[open]');
    if (dialog && immediate) return document.querySelector('#search-modal')?.closeDialog?.({ immediate: true, restoreFocus: false });
    if (dialog) document.querySelector('#search-modal .predictive-search__close-modal-button')?.click();
  };
  const closeBag = (immediate = false) => {
    const dialog = document.querySelector('#cart-drawer dialog[open]');
    if (dialog && immediate) return document.querySelector('#cart-drawer')?.close?.({ immediate: true, restoreFocus: false });
    if (dialog) document.querySelector('#cart-drawer')?.close?.();
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const cartCloseTrigger = event.target.closest('[data-bb-cart-close]');
    if (cartCloseTrigger) {
      event.preventDefault();
      closeBag();
      return;
    }
    if (event.target.matches('#search-modal dialog')) closeSearch();
    const searchTrigger = event.target.closest('[aria-controls="search-modal"]');
    const bagTrigger = event.target.closest('[aria-controls="cart-drawer"]');
    const menuTrigger = event.target.closest('[data-bb-quick-access] > summary');
    const filterTrigger = event.target.closest('[data-bb-filter-open], [data-bb-sort-open]');
    if (searchTrigger) { closeMenu(); closeBag(true); }
    if (bagTrigger) { closeMenu(); closeSearch(true); }
    if (menuTrigger) { closeSearch(true); closeBag(true); }
    if (filterTrigger) { closeMenu(); closeSearch(true); closeBag(true); }
    if (searchTrigger || bagTrigger || menuTrigger) document.dispatchEvent(new Event('bb:close-filters'));
  }, true);

  // Includes native automatic Bag opening after a confirmed add.
  document.addEventListener('theme-drawer:open', (event) => {
    if (event.target.id !== 'cart-drawer') return;
    closeMenu(); closeSearch(true);
    document.dispatchEvent(new Event('bb:close-filters'));
  });

  // Native dialog events do not bubble. Capture also covers keyboard/programmatic
  // Search opens, after its input has received native focus.
  document.addEventListener('dialog:open', (event) => {
    if (event.target.id !== 'search-modal') return;
    closeMenu(); closeBag(true);
    document.dispatchEvent(new Event('bb:close-filters'));
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('#search-modal form[role="search"]');
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    if (!input?.value.trim()) {
      event.preventDefault();
      input?.focus();
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const input = event.target.closest('#search-modal input[name="q"]');
    if (!input || input.value.trim()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    input.focus();
  }, true);
})();
